import { API_URL, apiFetch } from '../../api';
import { felmeddelande } from '../../utils/felmeddelanden.js';

function formatApiErrorDetail(detail) {
  if (detail == null) return '';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((it) => {
        if (!it) return '';
        if (typeof it === 'string') return it;
        const msg = it?.msg != null ? String(it.msg) : '';
        const loc = Array.isArray(it?.loc) ? it.loc.join('.') : (it?.loc != null ? String(it.loc) : '');
        return [loc, msg].filter(Boolean).join(': ');
      })
      .filter(Boolean)
      .join('; ');
  }
  if (typeof detail === 'object') {
    if (detail?.msg != null) return String(detail.msg);
    try {
      return JSON.stringify(detail);
    } catch {
      return String(detail);
    }
  }
  return String(detail);
}

async function parseApiError(res, fallbackMessage) {
  let detalj = null;
  try {
    const data = await res.json();
    if (data?.detail != null) {
      const formatted = formatApiErrorDetail(data.detail);
      if (formatted) detalj = formatted;
    }
  } catch {
    try {
      const text = await res.text();
      const trimmed = String(text || '').trim();
      if (trimmed) detalj = trimmed.slice(0, 400);
    } catch {
      // ignore
    }
  }
  return felmeddelande(res.status, detalj, fallbackMessage || 'ICE svarade inte som väntat. Försök igen om en stund.', {
    behorighet: 'Du saknar behörighet till ICE. Kontakta din administratör.',
  });
}

export async function iceFetchJson(path, options = {}, { errorMessage } = {}) {
  const url = `${API_URL}${path}`;
  const res = await apiFetch(url, options);
  if (!res.ok) {
    throw new Error(await parseApiError(res, errorMessage));
  }
  const cloned = res.clone();
  try {
    return await res.json();
  } catch {
    const text = await cloned.text();
    const preview = String(text || '').slice(0, 200);
    throw new Error(`Expected JSON from API. Got: ${preview}`);
  }
}

function parseContentDispositionFilename(value) {
  const cd = String(value || '');
  const match = cd.match(/filename\*?=(?:UTF-8''|\")?([^;\"\n\r]+)\"?/i);
  if (!match) return '';
  const raw = String(match[1] || '').trim();
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

export async function iceDownload(path, { filenameFallback = 'download' } = {}) {
  const url = `${API_URL}${path}`;
  const res = await apiFetch(url, { method: 'GET' });
  if (!res.ok) {
    throw new Error(await parseApiError(res, 'Filen kunde inte laddas ner. Försök igen om en stund.'));
  }

  const blob = await res.blob();
  const filename =
    parseContentDispositionFilename(res.headers.get('content-disposition')) ||
    String(filenameFallback || 'download');

  const blobUrl = window.URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    window.URL.revokeObjectURL(blobUrl);
  }
}
